// extracted by mini-css-extract-plugin
export var text = "_16-0";